import React from 'react';

const FujiEffect = () => {
  // 桜の花びらを生成
  const generatePetals = () => {
    const petals = [];
    for (let i = 0; i < 20; i++) {
      petals.push({
        id: i,
        left: `${Math.random() * 100}%`,
        animationDelay: `${Math.random() * 5}s`,
        animationDuration: `${5 + Math.random() * 5}s`,
      });
    }
    return petals;
  };

  const petals = generatePetals();

  const styles = {
    effectContainer: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      overflow: 'hidden',
      background: 'linear-gradient(180deg, #ffd6e8 0%, #ffb3d9 30%, #ff99cc 60%, #e6739f 100%)',
    },
    sun: {
      position: 'absolute',
      top: '15%',
      left: '50%',
      transform: 'translateX(-50%)',
      width: '150px',
      height: '150px',
      borderRadius: '50%',
      background: 'radial-gradient(circle, #ffebe6 0%, #ff6b6b 100%)',
      boxShadow: '0 0 60px rgba(255, 107, 107, 0.6)',
      animation: 'pulse 4s ease-in-out infinite',
    },
    fujiMountain: {
      position: 'absolute',
      bottom: '0',
      left: '50%',
      transform: 'translateX(-50%)',
      width: '0',
      height: '0',
      borderLeft: '400px solid transparent',
      borderRight: '400px solid transparent',
      borderBottom: '500px solid #1e3a8a',
      filter: 'drop-shadow(0 -5px 20px rgba(30, 58, 138, 0.3))',
    },
    fujiSnow: {
      position: 'absolute',
      bottom: '300px',
      left: '50%',
      transform: 'translateX(-50%)',
      width: '0',
      height: '0',
      borderLeft: '150px solid transparent',
      borderRight: '150px solid transparent',
      borderBottom: '200px solid #ffffff',
      filter: 'drop-shadow(0 0 10px rgba(255, 255, 255, 0.8))',
    },
    cloudLayer: {
      position: 'absolute',
      bottom: '200px',
      left: 0,
      width: '200%',
      height: '150px',
      background: 'linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, 0.3) 25%, rgba(255, 255, 255, 0.5) 50%, rgba(255, 255, 255, 0.3) 75%, transparent 100%)',
      animation: 'cloudMove 30s linear infinite',
    },
    petal: {
      position: 'absolute',
      top: '-50px',
      width: '10px',
      height: '10px',
      background: 'radial-gradient(circle, #ffb3d9 0%, #ff99cc 100%)',
      borderRadius: '50% 0 50% 50%',
      transform: 'rotate(45deg)',
      animation: 'fall linear infinite',
      opacity: 0.8,
    },
    sakuraTree: {
      position: 'absolute',
      bottom: '0',
      left: '10%',
      width: '150px',
      height: '300px',
      background: 'linear-gradient(180deg, transparent 0%, transparent 40%, #5d4037 40%, #5d4037 100%)',
      animation: 'sway 3s ease-in-out infinite',
    },
    sakuraBranch: {
      position: 'absolute',
      top: '30%',
      left: '50%',
      width: '200px',
      height: '200px',
      borderRadius: '50%',
      background: 'radial-gradient(circle, rgba(255, 179, 217, 0.6) 0%, rgba(255, 153, 204, 0.4) 50%, transparent 70%)',
      transform: 'translateX(-50%)',
    },
  };

  return (
    <div style={styles.effectContainer}>
      <style>
        {`
          @keyframes pulse {
            0%, 100% {
              transform: translateX(-50%) scale(1);
            }
            50% {
              transform: translateX(-50%) scale(1.05);
            }
          }

          @keyframes cloudMove {
            0% {
              transform: translateX(0);
            }
            100% {
              transform: translateX(-50%);
            }
          }

          @keyframes fall {
            0% {
              top: -50px;
              transform: rotate(45deg) translateX(0);
            }
            100% {
              top: 100%;
              transform: rotate(405deg) translateX(100px);
            }
          }

          @keyframes sway {
            0%, 100% {
              transform: rotate(0deg);
            }
            50% {
              transform: rotate(2deg);
            }
          }
        `}
      </style>

      {/* 太陽 */}
      <div style={styles.sun}></div>

      {/* 富士山 */}
      <div style={styles.fujiMountain}></div>
      <div style={styles.fujiSnow}></div>

      {/* 雲 */}
      <div style={styles.cloudLayer}></div>

      {/* 桜の木 */}
      <div style={styles.sakuraTree}>
        <div style={styles.sakuraBranch}></div>
      </div>

      {/* 桜の花びら */}
      {petals.map((petal) => (
        <div
          key={petal.id}
          style={{
            ...styles.petal,
            left: petal.left,
            animationDelay: petal.animationDelay,
            animationDuration: petal.animationDuration,
          }}
        />
      ))}
    </div>
  );
};

export default FujiEffect;